import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab } from '@mui/material';
import SystemHealthPage from '../SystemConfiguration/SystemHealthPage';
import APIManagementPage from './APIManagementPage';
import BackupsPage from '../Security&Compliance/BackupsPage';

const TAB_COMPONENTS = [SystemHealthPage, APIManagementPage, BackupsPage];

export default function ITServicesPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const ActiveComponent = TAB_COMPONENTS[tab] || SystemHealthPage;

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label={t('itServices.monitoring', 'Monitoring')} />
        <Tab label={t('itServices.apiManagement', 'API Management')} />
        <Tab label={t('itServices.backups', 'Backups')} />
      </Tabs>
      <ActiveComponent />
    </Box>
  );
}
